import React from "react";
import {  Statistic, Card, Row, Col } from 'antd'
import { SubscriptionIcon, TipsIcon } from "../Icon";
import { Typography, Button, List, PageHeader } from 'antd';
const { Text, Paragraph } = Typography;

const RevenueCard = () => {
  const revenueArr = [
    {
      subscriptionAmount: '16.80',
      tipAmount: '16,80',
      totalCommision: '25,20',
      totalProfit: '21.50'
    }
  ]
  return(
    <div className="dashboard-revenu">
      <Card className="revenu-content">
        <PageHeader
        title="Revenue"
        className="revenu-header"
        />
  
       {revenueArr.map(element => (
         <div>
           <div className="revenue-top-rows">
             <div className="revenue-columns">
               <SubscriptionIcon />
               <Text className="revenu-sub-titles">Subscription</Text>
            </div>
            <Text>${element.subscriptionAmount}</Text>
            <Text>${element.subscriptionAmount}</Text>
          </div>
           <div className="revenue-top-rows">
             <div className="revenue-columns">
               <TipsIcon />
               <Text className="revenu-sub-titles">Tips</Text>
             </div>
             <Text>${element.tipAmount}</Text>
             <Text>${element.tipAmount}</Text>
          </div>
          <div className="revenu-total">
            <Text className="revenu-total-sub-title">Total</Text>
            <Text className="revenu-total-sub-title"><span className="revenue-inner-title">Commision</span>${element.totalCommision}</Text>
            <Text className="revenu-total-sub-title"><span className="revenue-inner-title">Profit</span>${element.totalProfit}</Text>
          </div>
        </div>
       ))}
      </Card>
    </div>
  )
}

export default RevenueCard;